import React, { PureComponent } from 'react';

import Icon from '~/core/scripts/components/icon';

class WaveVizControls extends PureComponent {
  render() {
    const { togglePlay, isPlaying, showMuteButton, toggleMute, isMuted } = this.props;
    const playIcon = isPlaying ? 'pause-circle' : 'play-circle';

    return (
      <div className="waveviz__controls">
        <button
          className="waveviz__controls-play"
          onClick={togglePlay}
        >
          <Icon type={playIcon} />
        </button>
        {showMuteButton && (
          <button
            className="waveviz__controls-mute"
            onClick={toggleMute}
          >
            Sound {isMuted ? 'an' : 'aus'}
          </button>
        )}
      </div>
    );
  }
}

export default WaveVizControls;